import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Card, Button, Tooltip, Skeleton, Modal, Input } from "antd";
import PDFViewer from "pdf-viewer-reactjs";
import {
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { isMobile, isBrowser } from "react-device-detect";
import { MsgBox } from "../../../shared/custom-ant-d";
import { useReactToPrint } from "react-to-print";
import {
  reqPostDownloadBase64,
  reqPutDownloadFile,
  reqPostRespondToOffer,
} from "../../../axios/api";
import { CustomAlertModal } from "../../../shared";
import { GlobalApiErrorHandler } from "../../../shared/helpers";

const contentType = "application/pdf";
const zoomForDesktop = "100";

export const _openOffer = (props) => {
  const { selectedOffer, setSelectedOffer, setOfferList } = props;
  const history = useHistory();
  const [offerBase64, setOfferBase64] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    var formData = new FormData();
    formData.append(
      "blobcontainer",
      selectedOffer.offerLetterAzureContainerName
    );
    formData.append("filename", selectedOffer.offerLetterFileName);

    reqPostDownloadBase64(formData)
      .then((res) => {
        if (!res.data.isSuccess) {
          MsgBox({
            type: "error",
            message: "",
            description: res.data.fileObj,
          });
          setSelectedOffer(null);
          return false;
        }

        setOfferBase64(res.data.fileObj);

        if (isBrowser) {
          generatePDFViewerForDesktop(res.data.fileObj);
        }
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }, [selectedOffer]);

  const generatePDFViewerForDesktop = (base64) => {
    let blob = b64toBlob(base64, contentType);
    let blobUrl = URL.createObjectURL(blob);

    setPdfBlobUrl(blobUrl);
  };

  const onBack = () => {
    setOfferList(null);
    setSelectedOffer(null);
    return history.push({
      pathname: "/offers",
      search: "",
      state: null,
    });
  };

  const onDownload = () => {
    var formData = new FormData();
    formData.append(
      "blobcontainer",
      selectedOffer.offerLetterAzureContainerName
    );
    formData.append("filename", selectedOffer.offerLetterFileName);
    reqPutDownloadFile(formData)
      .then((res) => {
        generateDownloadLink(
          res.data,
          selectedOffer.offerLetterFileName,
          res.headers["content-type"]
        );
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  };

  const onSubmitOffer = (e, type) => {
    e.preventDefault();
    if (type == "ACCEPT") {
      doSubmit(type, null);
    } else if (type == "DECLINE") {
      setIsModalVisible(true);
    }
  };
  const doSubmit = (type, comment) => {
    setIsLoading(true);
    var ret_data = {
      OfferID: selectedOffer.offerID,
      ApplicationID: selectedOffer.applicationID,
      Action: type,
      ApplicantDeclineComments: comment,
      TimeStamp: selectedOffer.timeStamp,
    };

    var jsonStr = JSON.stringify(ret_data);

    reqPostRespondToOffer(jsonStr)
      .then((res) => {
        if (res.data.isSuccess) {
          MsgBox({
            type: "success",
            message: "",
            description: "This offer was successfully submitted.",
          });
        } else {
          MsgBox({
            type: "error",
            message: "",
            description: res.data.errorMessage,
          });
        }
        onBack();
      })
      .catch((err) => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const componentRef = useRef();
  const doPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const onModalOk = () => {
    let comment = document.getElementById("reject-comment-textfield").value;

    if (comment.length === 0 || !comment.trim()) {
      MsgBox({
        type: "error",
        message: "",
        description: "Your comment is required before submitting.",
      });
      return false;
    }
    doSubmit("DECLINE", comment);
    setIsModalVisible(false);
  };

  const onModalCancel = () => {
    setIsModalVisible(false);
  };

  const generateDownloadLink = (theBlob, fileName, contentType) => {
    var blob = new Blob([theBlob], { type: contentType });
    var blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = fileName;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  };

  const Extra = () => {
    return (
      <>
        <div style={{ marginBottom: "10px", textAlign: "center" }}>
          <Tooltip title="Download PDF">
            <Button onClick={(e) => onDownload()}>Download</Button>
          </Tooltip>
          {/**{'  '}
          <Tooltip title="Print PDF">
            <Button onClick={e => doPrint()}>Print</Button>
          </Tooltip>**/}
          {"  "}
          <Tooltip title="Back to Offers">
            <Button onClick={(e) => onBack()}>My Offers</Button>
          </Tooltip>
        </div>
      </>
    );
  };

  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {
      type: contentType,
      headers: {
        filename: "test.pdf",
      },
    });
    return blob;
  };

  const CustomNavigation = (data) => {
    const { page, pages } = data;
    const { handlePrevClick, handleNextClick } = data;
    const {
      handleZoomIn,
      handleResetZoom,
      handleZoomOut,
      maxScale,
      minScale,
      scale,
    } = data;

    return (
      <div className="custom-pdf-viewer-navigation">
        {isMobile ? (
          <></>
        ) : (
          <>
            <div className="custom-pdf-nav-container">
              <Button
                //shape="circle"
                className="custom-pdf-nav-btn"
                onClick={handleZoomIn}
                disabled={maxScale == scale}
              >
                <ZoomInOutlined />
              </Button>{" "}
              <Button
                //shape="circle"
                className="custom-pdf-nav-btn"
                onClick={handleResetZoom}
              >
                <UndoOutlined />
              </Button>{" "}
              <Button
                className="custom-pdf-nav-btn"
                //shape="circle"
                onClick={handleZoomOut}
                disabled={minScale == scale}
              >
                <ZoomOutOutlined />
              </Button>
            </div>
          </>
        )}

        <div>
          <Button
            className="custom-pdf-nav-btn"
            //shape="circle"
            onClick={handlePrevClick}
            disabled={page === 1}
          >
            <LeftOutlined />
          </Button>{" "}
          <span
            style={{
              display: "inline-block",
              marginTop: "5px",
              color: "white",
            }}
          >
            Page {page} from {pages}
          </span>{" "}
          <Button
            className="custom-pdf-nav-btn"
            //shape="circle"
            onClick={handleNextClick}
            disabled={page === pages}
          >
            <RightOutlined />
          </Button>
        </div>
      </div>
    );
  };

  const BrowserPDFViewer = () => {
    return (
      <Skeleton loading={pdfBlobUrl == null} active>
        <div>
          <object
            data={pdfBlobUrl + "#zoom=" + zoomForDesktop}
            type={contentType}
            width="100%"
            height="800px"
          >
            <p>
              Your web browser doesn't have a PDF plugin. Instead you can{" "}
              <a href={pdfBlobUrl}>click here to download the PDF file.</a>
            </p>
          </object>
        </div>
      </Skeleton>
    );
  };

  const CustomPDFViewer = () => {
    return (
      <>
        <Skeleton loading={offerBase64 == null} active>
          <>
            <PDFViewer
              document={{
                base64: offerBase64,
                //url: 'https://arxiv.org/pdf/quant-ph/0410100.pdf',
              }}
              navigation={CustomNavigation}
              scale={2.0}
              navbarOnTop={true}
            />
            <div style={{ display: "none" }}>
              <PDFViewer
                document={{
                  base64: offerBase64,
                  //url: 'https://arxiv.org/pdf/quant-ph/0410100.pdf',
                }}
                hideNavbar={true}
                ref={componentRef}
              />
            </div>
          </>
        </Skeleton>
      </>
    );
  };

  return (
    <>
      <CustomAlertModal
        type="confirm"
        content="Are you sure you want to accept this offer?"
        onCancel={() => setShowConfirm(false)}
        visible={showConfirm}
        destroyOnClose={true}
        footer={[
          <Button
            key="yes"
            onClick={(e) => {
              e.preventDefault();
              onSubmitOffer(e, "ACCEPT");
              setShowConfirm(false);
            }}
            type="danger"
          >
            Yes
          </Button>,
          <Button key="no" onClick={(e) => setShowConfirm(false)} type="danger">
            No
          </Button>,
        ]}
      />
      <Row justify="left">
        <Col md={24} xs={24}>
          <Card
            title={`${selectedOffer.jobTitleName} - #${selectedOffer.jobReqID}`}
            className={
              "documents-card iqor-header " + (isMobile ? "mobile-card" : "")
            }
            extra={
              isBrowser ? (
                <>
                  <Tooltip title="Back to Offers">
                    <Button onClick={(e) => onBack()}>My Offers</Button>
                  </Tooltip>
                </>
              ) : (
                <></>
              )
            }
          >
            {isMobile ? <Extra /> : <></>}

            {isBrowser ? (
              <>
                <BrowserPDFViewer />
              </>
            ) : (
              <CustomPDFViewer />
            )}

            {offerBase64 == null ||
            selectedOffer.offerAccptStatus !== "Pending" ? (
              <></>
            ) : (
              <div style={{ marginTop: "15px" }}>
                <div style={{ textAlign: "center" }}>
                  By clicking Accept Offer you understand and agree to the terms
                  of this offer.
                </div>

                <div style={{ marginTop: "10px", textAlign: "center" }}>
                  <Button
                    loading={isLoading}
                    type="danger"
                    htmlType="button"
                    onClick={(e) => setShowConfirm(true)}
                  >
                    Accept Offer
                  </Button>{" "}
                  <Button
                    loading={isLoading}
                    type="danger"
                    htmlType="button"
                    onClick={(e) => onSubmitOffer(e, "DECLINE")}
                  >
                    Reject Offer
                  </Button>
                </div>
              </div>
            )}
          </Card>
        </Col>
      </Row>
      <Modal
        title="Reject Offer"
        visible={isModalVisible}
        closable={false}
        footer={[
          <Button key="back" onClick={onModalCancel} type="danger">
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={onModalOk} type="danger">
            Submit
          </Button>,
        ]}
      >
        <Input.TextArea
          placeholder="Can you tell us why you are rejecting the offer"
          allowClear
          rows={4}
          id="reject-comment-textfield"
          //onChange={e => onRejectCommentChange(e)}
        />
      </Modal>
    </>
  );
};
